import { render, staticRenderFns } from "./KpiTramite.vue?vue&type=template&id=13fc05a6&scoped=true&"
import script from "./KpiTramite.vue?vue&type=script&lang=js&"
export * from "./KpiTramite.vue?vue&type=script&lang=js&"
import style0 from "./KpiTramite.vue?vue&type=style&index=0&id=13fc05a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc05a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VDatePicker,VFlex,VIcon,VLayout,VMenu,VSelect,VTextField})
